import React from 'react';
import { FiX } from 'react-icons/fi';

interface TempDisableConfirmationModalProps {
  isOpen: boolean;
  memberName: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const FiXComponent = FiX as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const TempDisableConfirmationModal: React.FC<
  TempDisableConfirmationModalProps
> = ({ isOpen, memberName, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  // Closes the modal without disabling the user
  const handleCancel = () => {
    onCancel();
  };

  // Confirms the temporary disable action and triggers the provided callback
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
      <div className='bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative'>
        {/* Close button */}
        <button
          onClick={handleCancel}
          className='absolute right-4 top-4 text-gray-500 hover:text-gray-700'
        >
          <FiXComponent size={20} />
        </button>

        <h2 className='text-[24px] font-semibold text-[#3F5265] mb-2'>
          Temporarily Disable
        </h2>
        <p className='text-[#657584] mb-4 text-[16px]'>
          Temporarily remove this member’s access without deleting their
          account.
        </p>

        {/* Warning box */}
        <div className='bg-red-50 text-red-700 rounded-md p-4 mb-6 text-[14px]'>
          <p className='font-medium mb-2'>
            You’re about to Temporarily disable the access for {memberName}.
          </p>
          <ul className='list-disc ml-5 space-y-1'>
            <li>
              This user will no longer be able to log in or access any part of
              this account.
            </li>
            <li>They will not be notified automatically.</li>
            <li>You can reinstate access at any time.</li>
          </ul>
          <p className='mt-2'>Are you sure you want to proceed?</p>
        </div>

        {/* Actions */}
        <div className='flex justify-end gap-3'>
          <button
            onClick={handleCancel}
            className='px-4 py-2 rounded border border-gray-300 text-gray-700 bg-white hover:bg-gray-100'
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className='px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600'
          >
            Temporarily Disable User
          </button>
        </div>
      </div>
    </div>
  );
};

export default TempDisableConfirmationModal;
